export const openPrimaryPanel = () => ({
	type: 'SHOW_PRIMARY',
})

export const closePrimaryPanel = () => ({
	type: 'HIDE_PRIMARY',
})
